
import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import highResDesktopImageWebp from './images/brokerage-accounts-services-hero.webp';
import highResMobileImageWebp from './images/brokerage-accounts-services-hero-mobile.webp';
// low res images
import {
  lowResImageDesktop,
  lowResImageMobile,
} from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='brokerage-accounts-services-hero'
      moduleName='hero-module'
      moduleVariation='A'
      productName={<>Brokerage Accounts &#38; Services</>}
      headingText={<>Investment tools for wherever you are <WidowBlock>in life.</WidowBlock></>}
      descriptionText={<>Whether you&#39;re ready to start saving for a child&#39;s education, thinking about buying a home, or looking ahead to retirement, we can help you take your investments to the next level.</>}
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Start investing',
        ariaLabel: 'Start investing with a financial professional.',
        children: '',
      }}
      backgroundImageAriaLabel='Happy parents playing soccer with their two daughters on a soccer field on a sunny day'
      backgroundImageDesktop={highResDesktopImageWebp.toString()}
      backgroundImageMobile={highResMobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );};
